module.exports = "/dist/assets/images/noRxImageSmall.png";